<div
  class="toast-wrapper"
  [class]="toast.type"
  [class.persistent]="toast.persistent"
  (mouseenter)="destroyPause = true"
  (mouseleave)="destroyPause = false"
>
  <div class="icon">
    @switch (toast.type) {
      @case ('info') {
        <fa-icon [icon]="faInfoCircle" class="text-light-blue"></fa-icon>
      }
      @case ('success') {
        <fa-icon [icon]="faCheckCircle" class="text-green"></fa-icon>
      }
      @case ('warning') {
        <fa-icon [icon]="faExclamationTriangle" class="text-yellow"></fa-icon>
      }
      @case ('alert') {
        <fa-icon [icon]="faExclamationCircle" class="text-red"></fa-icon>
      }
      @case ('update') {
        <fa-icon [icon]="faSync" class="text-light-blue"></fa-icon>
      }
    }
  </div>
  @if (toast.value) {
    <div class="content" [innerHTML]="toast?.value | transloco"></div>
  }
  @if (!toast.value) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
  @if (toast.actions && toast.actions.length > 0) {
    <div class="actions gap-2">
      @for (action of toast.actions; track action) {
        <button class="action-button" (click)="executeAction(action)">
          {{ action.label | transloco }}
        </button>
      }
    </div>
  }
  @if (!fixed) {
    <div class="close" (click)="destroy()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </div>
  }
  @if (!fixed && !toast.persistent) {
    <div class="progress" [style.animation-duration]="duration + 'ms'"></div>
  }
</div>
